import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import TableSort from '../../../shared/components/TableSort';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import DocumentState from '../../../shared/model/DocumentState';
import Badge from '../../../shared/components/Badge';
import Link from 'react-router-dom/Link';
import _ from 'lodash';
import Dropdown from '../../../shared/components/dropdown/Dropdown';
import { PsDocumentRouteGenerator } from '../../../shared/document/PsDocumentRouteGenerator';
import { PsDocument } from '../../../shared/document/list/PsDocument';

/**
 * Componentes con conjuntos de pseudo columnas fijas agrupadas como una única columna para su fijación.
 */

export const SortColumnNames = {
    WORKER_DNI: 'worker-dni',
    WORKER_NAME: 'worker-name',
};

const CSSFixedColumns = {
    WORKER_DOCUMENTS: {
        minWidth: 40,
        maxWidth: 40,
        width: 40,
        paddingLeft: 0,
        paddingRight: 0,
    },
    WORKER_DNI: {
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        paddingLeft: 10,
        paddingRight: 10,
    },
    WORKER_NAME: {
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        paddingLeft: 10,
        paddingRight: 10,
    },
    WORKER_CHECK_TYPES: {
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        paddingLeft: 10,
        paddingRight: 10,
    },
};

const validation = ({ document_state }) =>
    document_state.id === DocumentState.VALIDATED ||
    document_state.id === DocumentState.ARCHIVED ||
    document_state.id === DocumentState.NO_APPLY;

const pending = ({ document_state }) =>
    document_state.id === DocumentState.PENDING_VALIDATION;

export class MonthlyTableThs extends React.Component {

    render() {
        const {
            showDocumentsOfWorker,
            columnSortAsc,
            columnSortedSelected,
            onSortByColumn,
            zIndex,
            fixedThs,
        } = this.props;

        const thPositionStyle = !fixedThs ? { position: 'relative' } : {};

        return (
            <th
                className="fixed-th"
                style={{ zIndex: zIndex, ...thPositionStyle }}
            >
                <div className="fixed-th-container">
                    {
                        showDocumentsOfWorker && (
                            <div
                                className="fixed-pseudo-th"
                                style={CSSFixedColumns.WORKER_DOCUMENTS}
                            />
                        )
                    }
                    <TableSort
                        id={SortColumnNames.WORKER_DNI}
                        asc={columnSortAsc[SortColumnNames.WORKER_DNI]}
                        selected={columnSortedSelected === SortColumnNames.WORKER_DNI}
                        label={I18nUtils.tr('TR_DNI_NIF')}
                        className="fixed-pseudo-th"
                        style={CSSFixedColumns.WORKER_DNI}
                        onSort={onSortByColumn}
                    />
                    <TableSort
                        id={SortColumnNames.WORKER_NAME}
                        asc={columnSortAsc[SortColumnNames.WORKER_NAME]}
                        selected={columnSortedSelected === SortColumnNames.WORKER_NAME}
                        label={I18nUtils.tr('TR_TRABAJADOR')}
                        className="fixed-pseudo-th"
                        style={CSSFixedColumns.WORKER_NAME}
                        onSort={onSortByColumn}
                    />
                    {
                        this.renderWorkCheckTypes()
                    }
                </div>
            </th>
        );
    }

    renderWorkCheckTypes() {
        const {
            workCheckTypes,
            workCheckStates,
            showMultipleValidation,
            onChangeWorkCheckTypeAll,
        } = this.props;

        return workCheckTypes.map((workCheckType, i) => {
            const {
                id,
                name,
                multiple_validation,
            } = workCheckType;

            return (
                <div
                    key={i}
                    className="fixed-pseudo-th"
                    style={CSSFixedColumns.WORKER_CHECK_TYPES}
                >
                    {name}
                    {
                        showMultipleValidation && multiple_validation && (
                            <Dropdown
                                defaultText={I18nUtils.tr('TR_CAMBIAR_TODOS')}
                                value={-1}
                                onChange={(option) => onChangeWorkCheckTypeAll(id, option.value)}
                                options={workCheckStates.map((workCheckState) => ( {
                                    ...workCheckState,
                                    value: workCheckState.id,
                                    title: workCheckState.name,
                                } ))}
                            />
                        )
                    }
                </div>
            );
        });
    }

}

export class MonthlyTableTds extends React.Component {

    _documentRouteGenerator = new PsDocumentRouteGenerator();

    render() {
        const { worker, zIndex } = this.props;
        const completeName = `${worker.name} ${worker.last_name}`;

        return (
            <td
                className={'fixed-td'}
                style={{ zIndex }}
            >
                {
                    this.renderIconDocuments()
                }
                <div
                    className={'fixed-pseudo-td ellipsis'}
                    children={worker.dni}
                    style={CSSFixedColumns.WORKER_DNI}
                />
                <OverlayTrigger
                    placement={'bottom'}
                    overlay={
                        <Tooltip
                            id="tooltip-worker"
                            children={completeName}
                        />
                    }
                >
                    <div
                        className={'fixed-pseudo-td ellipsis'}
                        children={completeName}
                        style={CSSFixedColumns.WORKER_NAME}
                    />
                </OverlayTrigger>
                {
                    this.renderWorkCheckTypesSelects()
                }
            </td>
        );
    }

    renderIconDocuments() {
        const { worker, showDocumentsOfWorker } = this.props;
        const hasDocuments = worker.documents && worker.documents.length > 0;
        const render = showDocumentsOfWorker && hasDocuments;

        if ( !render ) return null;

        const documentsValid = worker.documents.every(validation);
        const documentsPending = worker.documents.some(pending);

        const classes = documentsValid
            ? ' text-valid'
            : documentsPending
                ? ' text-pending'
                : '';

        return (
            <div
                className={'fixed-pseudo-td dropdown'}
                style={CSSFixedColumns.WORKER_DOCUMENTS}
            >
                <div className="dropdown show">
                    <a
                        className={`dropdown-toggle ${classes}`}
                        id={'dropdownMenuLink'}
                        data-toggle={'dropdown'}
                        aria-haspopup={'true'}
                        aria-expanded={'false'}
                        role={'button'}
                    >
                        <i className="material-icons">
                            description
                        </i>
                    </a>
                    <div
                        className="dropdown-menu"
                        aria-labelledby={'dropdownMenuLink'}
                    >
                        <div className={'m-b-15'}>
                            <strong>{worker.name} {worker.last_name}</strong>
                        </div>
                        {
                            worker.documents.map((document) => {
                                const {
                                    id,
                                    name,
                                    document_state: {
                                        color,
                                    },
                                } = document;

                                const psDocument = PsDocument.fromAPIDocument(document);
                                const route = this._documentRouteGenerator.generateRoute(psDocument);

                                return (
                                    <p key={id} className="dropdown-item">
                                            <span>
                                                <Badge color={'#' + color}/>
                                            </span> {name}
                                        <br/>
                                        <Link
                                            to={route}
                                            target={'_blank'}
                                        >
                                            <small className="doc-link">
                                                {I18nUtils.tr('TR_VER_DOCUMENTO')}
                                            </small>
                                        </Link>
                                    </p>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }

    renderWorkCheckTypesSelects() {
        const {
            worker,
            monthChecksByWorker,
            workCheckTypes,
            workCheckStates,
            onChangeWorkCheckType,
        } = this.props;

        const monthChecksWorker = monthChecksByWorker[worker.id] || {};

        return workCheckTypes.map((workCheckType, i) => {

            let selectedState = -1;
            const checkTypeIds = _.mapKeys(monthChecksWorker, 'document_type_id');
            if ( checkTypeIds[workCheckType.id] ) {
                selectedState = checkTypeIds[workCheckType.id].worker_check_state_id;
            }

            return (
                <div
                    key={i}
                    className={'fixed-pseudo-td'}
                    style={CSSFixedColumns.WORKER_CHECK_TYPES}
                >
                    <Dropdown
                        value={selectedState}
                        options={[
                            { value: -1, title: '' },
                            ...workCheckStates.map((workCheckState) => ( {
                                ...workCheckState,
                                value: workCheckState.id,
                                title: workCheckState.name,
                            } )),
                        ]}
                        onChange={(option) => onChangeWorkCheckType(worker.id, workCheckType.id, option.value)}
                    />
                </div>
            );
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/components/MonthlyTableColumns.js